import * as React from 'react'

import { Box, CheckBox, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface Props {
  checked: boolean
  onClick: () => void
}

const StartsNextDayCheckbox = ({ checked, onClick }: Props) => {
  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <CheckBox checked={checked} onClick={onClick} />
      <Text.Normal size="200" weight="medium">
        {i18n.t('clock_in.checkbox_starts_next_day')}
      </Text.Normal>
    </Box>
  )
}

export default StartsNextDayCheckbox
